import React from 'react';
import { useIntl } from 'react-intl';
import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import styles from './HaOverviewSubHeader.module.scss';

type HaOverviewSubHeaderProps = {
  search: string;
  onSearchChange: (value: string) => void;
};

export function HaOverviewSubHeader({ search, onSearchChange }: HaOverviewSubHeaderProps) {
  const intl = useIntl();

  return (
    <div className={styles.subHeader}>
      <div className={styles.title}>
        {intl.formatMessage({ id: 'seriesbooking.haOverview.title' })}
      </div>

      <div className={styles.searchWrapper}>
        <TextField
          className={styles.searchInput}
          size="small"
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder={intl.formatMessage({ id: 'seriesbooking.haOverview.searchPlaceholder' })}
          autoComplete="off"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
            inputProps: {
              'data-form-type': 'other',
              'data-lpignore': 'true',
            },
          }}
        />
      </div>

      <div className={styles.spacer} />
    </div>
  );
}
